module.exports = __webpack_public_path__ + "static/media/ProgramValidationHero.4f070fa3.png";